import { ReviewScore } from "@sabyr-dev/mist_core/model/datasource/score";
import { ElibraryScoreFrontend } from "@sabyr-dev/mist_elibrary/frontend";

export class AcademyScoreFrontend extends ElibraryScoreFrontend {
	displayReviewScoreTable(scores: ReviewScore[], total: ReviewScore): void {
		const table = document.querySelector<HTMLTableElement>('table.scores');
		const rows = Array.from(table.querySelectorAll<HTMLTableRowElement>('tbody tr'));
		if (rows.length < scores.length) {
			for (let i = 0; i < scores.length - rows.length; i++) {
				const newRow = rows[0].cloneNode(true) as HTMLTableRowElement;
				rows[rows.length - 1].after(newRow);
				rows.push(newRow);
			}
		}
		scores.forEach((section, index) => {
			const row = rows[index];
			row.cells[0].textContent = section.section;
			row.cells[1].textContent = section.time;
			row.cells[2].textContent = section.correct.toString();
			row.cells[3].textContent = section.incorrect.toString();
			row.cells[4].textContent = section.unanswered.toString();
			row.cells[5].textContent = section.total.toString();
			row.cells[6].textContent = `${(section.percent * 100).toFixed(2)}%`;
		});
		const footer = table.querySelector<HTMLTableRowElement>('tfoot tr');
		footer.cells[1].textContent = total.time;
		footer.cells[2].textContent = total.correct.toString();
		footer.cells[3].textContent = total.incorrect.toString();
		footer.cells[4].textContent = total.unanswered.toString();
		footer.cells[5].textContent = total.total.toString();
		footer.cells[6].textContent = `${(total.percent * 100).toFixed(2)}%`;
	}
}
